import { useNavigate } from "react-router-dom"

import { MetricHeaderMid, MetricHeaderLeft, MetricHeaderRight, MetricHeaderWrapper } from "../Atom"
import { HeaderInfoNav } from "../Reusable"

export default function CustomerManagementHeader({ name }: any) {

    const navigate = useNavigate()

    const handleClickBack = (e: any) => {
        navigate(-1)
    }

    return (
        <>
            <MetricHeaderWrapper>

                <MetricHeaderLeft>
                    <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
                </MetricHeaderLeft>


                <MetricHeaderMid>
                </MetricHeaderMid>


                <MetricHeaderRight>
                </MetricHeaderRight>

            </MetricHeaderWrapper>
        </>
    )
}
